import { AnyAction, ListenerEffectAPI, ThunkDispatch } from '@reduxjs/toolkit';

import { AppRootState } from '../../../../../store/models/app-state.model';
import { getStatistics } from '../thunks/get-statistics.thunk';

export const StatisticsFiltersListenerEffect = (
  action: AnyAction,
  api: ListenerEffectAPI<
    AppRootState,
    ThunkDispatch<AppRootState, undefined, AnyAction>,
    unknown
  >
): void => {
  const appId = api.getState().appsFeature.statistics.appId;
  api.dispatch(getStatistics({ appId }));
};
